import { loadScript, getNovSchema } from "../../utility";
import { getProfileData, getBaseUrl } from "../../data/DataStore";
import flags from "featureFlags";

export const LOG_FEATURE_CLICK_ENDPOINT = "Logging/LogFeatureClick";
export const LOG_INTERACTION_ENDPOINT = "Logging/LogInteraction";
export const PROFILE_KEY = "profile";
export const PASSWORD_KEY = "password";
export const FEATURE_TYPE_KEY = "featureType";
export const ACTION_TYPE_KEY = "actionType";
export const EVENT_NAME_KEY = "eventName";
export const INTERACTION_TYPE_KEY = "interactionType";
export const SRC_ID_KEY = "srcIdentifier";
export const DEST_ID_KEY = "destIdentifier";

/**
 * Logs a user interaction. Sends a GET request to the Logging controller.
 * @param {string} featureType The feature being used by the user interaction
 * @param {string} sourceId The unique ID associated with the title being viewed
 * @param {string} destinationId The ID of the thing (ex: link, hover, title id) being used.
 */
export function logFeatureUsage(featureType, sourceId, destinationId) {
    let logRequestUrl = buildRequestUrl(featureType, sourceId, destinationId);

    loadScript(logRequestUrl);
}

/**
 * Constructs the URL to be used in the logging GET request based on the useAmplitudeLogger feature flag
 * When this feature flag is enabled, the URL is constructed passing in the additional data required for Amplitude
 * @param {object} featureType The specific user interaction feature
 * @param {string} sourceId
 * @param {string} destinationId
 * @returns {string} The fully qualified logging endpoint URL
 */
export function buildRequestUrl(featureType, sourceId, destinationId) {

    // TODO(dca): add guard clauses here
    if (flags.useAmplitudeLogger && featureType.interaction) {
        return encodeURI(buildLogInteractionUrlString(featureType.interaction, sourceId, destinationId));
    } else {
        return encodeURI(buildLogFeatureClickUrlString(featureType.featureClick, sourceId, destinationId));
    }
}


function buildLogInteractionUrlString(featureData, sourceId, destinationId){
    let novSchema = getNovSchema();
    let baseUrl = getBaseUrl();
    let userProfile = getProfileData();
    let profileId = userProfile.Profile;
	let password = userProfile.Password;

	return  `${novSchema}${baseUrl}/${LOG_INTERACTION_ENDPOINT}?${PROFILE_KEY}=${profileId}&${PASSWORD_KEY}=${password}`
		+`&${FEATURE_TYPE_KEY}=${featureData.featureType}&${SRC_ID_KEY}=${sourceId}&${DEST_ID_KEY}=${destinationId}&${EVENT_NAME_KEY}=${featureData.name}`
		+`&${INTERACTION_TYPE_KEY}=${featureData.interactionType}&${ACTION_TYPE_KEY}=${featureData.actionType}`;
}

function buildLogFeatureClickUrlString(featureData, sourceId, destinationId){
    let novSchema = getNovSchema();
    let baseUrl = getBaseUrl();
    let userProfile = getProfileData();
    let profileId = userProfile.Profile;
	let password = userProfile.Password;

	return `${novSchema}${baseUrl}/${LOG_FEATURE_CLICK_ENDPOINT}?${PROFILE_KEY}=${profileId}&${PASSWORD_KEY}=${password}`
	+ `&${FEATURE_TYPE_KEY}=${featureData.name}&${SRC_ID_KEY}=${sourceId}&${DEST_ID_KEY}=${destinationId}`;
}



// WEBPACK FOOTER //
// ./src/lib/analytics/NsLogger.js